"use strict";
export var ModalType = /* @__PURE__ */ ((ModalType2) => {
  ModalType2["CREATE"] = "create";
  ModalType2["UPDATE"] = "update";
  ModalType2["CLONE"] = "clone";
  ModalType2["CLONE_WITHOUT_FORM"] = "clone_without_form";
  return ModalType2;
})(ModalType || {});
